import { render, staticRenderFns } from "./footer-side.vue?vue&type=template&id=cd7d39ba&scoped=true&"
var script = {}
import style0 from "./footer-side.vue?vue&type=style&index=0&id=cd7d39ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7d39ba",
  null
  
)

export default component.exports